import { RestUrl } from "../common/cyan.types";

export class MemberInvitationUrl {
  public static getMyPendingMemberInvitations: RestUrl = ["GET", "/member/invitations/my-pending"];
  public static getMemberInvitationByToken: (token: string) => RestUrl = token => ["GET", `/member/invitations/${token}`];
  public static acceptMemberInvitationByToken: (token: string) => RestUrl = token => ["POST", `/member/invitations/${token}/accept`];
  public static rejectMemberInvitationByToken: (token: string) => RestUrl = token => ["POST", `/member/invitations/${token}/reject`];
}
